import { QuestionBase } from './question-base';
/*
Sample:

    new RangeQuestion({
      key: 'playtime',
      class: 'col s5',
      value: session ? session.playtime : ['00:00', '24:00'],
      config: {
        type: 'double',
        keyboard: true,
        grid: true,
        min: 0,
        max: 24 * 60,
        min_interval: 60,
        step: 30,
        from: 0,
        to: 24 * 60,
        extra_classes: 'margin-right margin-left',
        prettify: num => `${Math.floor(num / 60).toString().padStart(2, '0')}:${(num % 60).toString().padStart(2, '0')}`,
      },
      eventHandlers: {
        onSelected: playtimeRange => this.onPlaytimeRangeSelected(playtimeRange)
      }
    });
*/
export class RangeQuestion extends QuestionBase<any | any[]> {
  controlType = 'range';
  options: any;

  constructor(options: any = {}) {
    super(options);
    this.setOptions(options);
  }

  setOptions(options: any = {}) {
    this.options = {
      config: {
        disable: this.disabled || !this.editable
      }
    };
    Object.assign(this.options.config, options.config);
  }

  setDisabled(disabled) {
    super.setDisabled(disabled);
    this.options.config.disable = disabled;
    this.setOptions(this.options);
  }

  setEditable(editable) {
    super.setEditable(editable);
    this.options.config.disable = !editable;
    this.setOptions(this.options);
  }
}
